import React from 'react';
import { House, Building, TrendingUp, Briefcase } from 'lucide-react';
import { WHO_WE_HELP } from '@/data/site';

const ICON_MAP = { House, Building, TrendingUp, Briefcase };

export default function WhoWeHelp() {
  return (
    <section className="section-pad bg-ohana-bg" data-testid="who-we-help">
      <div className="container-ohana">
        <div className="max-w-3xl">
          <p className="overline">Who We Help</p>
          <h2 className="h-display text-4xl md:text-5xl mt-3 leading-tight">
            Built for the people who move properties forward.
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {WHO_WE_HELP.map((w) => {
            const Ico = ICON_MAP[w.icon];
            return (
              <div
                key={w.title}
                className="card-default !p-7"
                data-testid={`audience-${w.title.toLowerCase().replace(/\s+/g, '-')}`}
              >
                <span className="grid h-12 w-12 place-items-center rounded-xl bg-ohana-primary text-ohana-bg">
                  {Ico && <Ico className="h-6 w-6" />}
                </span>
                <h3 className="mt-5 font-serif text-2xl text-ohana-primary leading-snug">
                  {w.title}
                </h3>
                <p className="mt-3 text-ohana-text-muted text-sm md:text-base leading-relaxed">
                  {w.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
